import script from "./DaylightPieChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DaylightPieChart.vue?vue&type=script&setup=true&lang=ts"

import "./DaylightPieChart.vue?vue&type=style&index=0&id=32746965&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32746965"]])

export default __exports__